import { useEffect, useState } from 'react';

import { MinusCircleFilled, PlusCircleFilled } from '@ant-design/icons';
import useUserStore from '@lcsc-ui/store/user';
import indexBuriedPoint, { indexBuriedPointMyfunMap } from '@lcsc-ui/utils/_indexBuriedPoint';
import Domains from '@lcsc-ui/utils/domains';
import sendAxios from '@lcsc-ui/utils/request';
import Utils from '@lcsc-ui/utils/Utils';
import { Drawer, message, Skeleton, Popover } from 'antd';

import SvgIcon from '@/components/SvgIcon';

const spmMap = {
  my_order: 'dd',
  my_coupon: 'yhq',
  super_member_day: 'smd',
  my_invoice: 'fp',
};

const IndexMyApplication = () => {
  /**我的功能 */
  const [commonFixedFunctions, setCommonFixedFunctions] = useState(null);
  const [outSidemyApplicationListState, setOutSidemyApplicationListState] = useState(null);
  const [myFixedApplicationListState, setMyFixedApplicationListState] = useState(null);
  const [myApplicationListState, setMyApplicationListState] = useState(null);
  const [oftenUseApplicationListState, setOftenUseApplicationListState] = useState(null);
  const [moreApplicationLisStatet, setmoreApplicationLisStatet] = useState(null);
  const [showFunTip, setShowFunTip] = useState(false);
  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const { userInfo } = useUserStore();

  function getMyApplication() {
    sendAxios({
      method: 'get',
      url: `/get/my/application`,
      baseURL: Domains.lcscMemberUrl,
    }).then((res) => {
      if (res.code === 200) {
        setCommonFixedFunctions(res.result);
      }
    });
  }

  useEffect(() => {
    // 受登录状态影响
    getMyApplication();
  }, [userInfo]);

  useEffect(() => {
    if (commonFixedFunctions) {
      setOutSidemyApplicationListState(commonFixedFunctions.myApplicationList);
      setMyFixedApplicationListState(commonFixedFunctions.myApplicationList.slice(0, 4));
      setMyApplicationListState(commonFixedFunctions.myApplicationList.slice(4));
      setOftenUseApplicationListState(commonFixedFunctions.oftenUseApplicationList);
      setmoreApplicationLisStatet(commonFixedFunctions.moreApplicationList);
    }
  }, [commonFixedFunctions]);

  useEffect(() => {
    if (window?.localStorage && window?.localStorage.getItem('showIndexFunTips')) {
      setShowFunTip(false);
    }
  }, [isEdit, open]);

  const onShowFuncSettingDrawer = () => {
    if (window?.localStorage && !window?.localStorage.getItem('showIndexFunTips')) {
      setShowFunTip(true);
    }
    setOpen(true);
  };

  function setTipLocal() {
    if (window?.localStorage && !window?.localStorage.getItem('showIndexFunTips')) {
      window?.localStorage.setItem('showIndexFunTips', 'false');
    }
  }
  const onCloseFuncSettingDrawer = () => {
    setOpen(false);
    setMyApplicationListState(outSidemyApplicationListState.slice(4));
    setIsEdit(false);
    setTipLocal();
  };

  const onEditFuncSettingDrawer = () => {
    setIsEdit(true);
    setTipLocal();
  };

  const onSaveFuncSettingDrawer = () => {
    setIsEdit(false);
    onCloseFuncSettingDrawer();
    // 发起保存请求
    const applicationTypes = myApplicationListState.map((t) => t.applicationType);
    const outSideApplicationTypes = outSidemyApplicationListState.slice(4).map((t) => t.applicationType);
    if (JSON.stringify(applicationTypes) === JSON.stringify(outSideApplicationTypes)) {
      // 未做改变
      return;
    }
    // 成功
    setMyApplicationListState(myApplicationListState);
    setOutSidemyApplicationListState(myFixedApplicationListState.concat(myApplicationListState));
    sendAxios({
      method: 'post',
      url: `/async/set/my/application`,
      baseURL: Domains.lcscMemberUrl,
      data: applicationTypes,
    }).then((res) => {
      if (res.needLogin) {
        Utils.showWindowLogin();
        message.warning('请登陆后操作！');
        return;
      }
      if (res.code === 200) {
        message.success('保存成功！');
      }
    });
  };

  const onCancelEditFuncSettingDrawer = () => {
    setMyApplicationListState(outSidemyApplicationListState.slice(4));
    setIsEdit(false);
    setTipLocal();
  };

  const removeFunction = (func, e) => {
    e.preventDefault();
    setMyApplicationListState(myApplicationListState.filter((f) => f.applicationType !== func.applicationType));
  };

  const addFunction = (func, e) => {
    e.preventDefault();
    if (myApplicationListState.length >= 8) {
      message.warning('您已有8个自定义功能，如需修改请删除部分功能再新增');
      return;
    }
    setMyApplicationListState([...myApplicationListState, func]);
  };

  const extra = (
    <>
      {isEdit ? (
        <div className="flex items-center">
          <button
            className="bg-white text-black border border-solid border-[#dbdbdb] text-[14px] w-[65px] h-[28px] leading-[28px] rounded-[6px] mr-[8px]"
            onClick={onCancelEditFuncSettingDrawer}
          >
            取消
          </button>
          <button
            className="bg-lcBlue text-white text-[14px] w-[65px] h-[28px] leading-[28px] rounded-[6px]"
            onClick={onSaveFuncSettingDrawer}
          >
            保存
          </button>
        </div>
      ) : (
        <Popover open={showFunTip} placement="topRight" title="" content="首页我的功能可支持自定义了，点击编辑试试。">
          <button
            className="bg-lcBlue text-white text-[14px] w-[65px] h-[28px] leading-[28px] rounded-[6px]"
            onClick={onEditFuncSettingDrawer}
          >
            编辑
          </button>
        </Popover>
      )}
    </>
  );

  const [isHoverMySetting, setIsHoverMySetting] = useState(null);
  const changeEnter = (type) => {
    setIsHoverMySetting(type);
  };
  return (
    <div id="func-area" className="pt-[15px]" data-spm="fn">
      <div className="flex justify-between items-center">
        <h3 className="text-[14px] text-black font-bold leading-[19px] mb-0 antialiased">我的功能</h3>
        <button
          title="全部功能"
          className="text-[#56657F] leading-[16px] hover:text-lcBlue antialiased"
          onClick={onShowFuncSettingDrawer}
        >
          全部
        </button>
        <Drawer className="index-func" title="全部功能" onClose={onCloseFuncSettingDrawer} open={open} extra={extra}>
          <div data-spm="fn">
            <p className="font-bold text-[14px]">我的功能</p>
            {/* 固定功能 */}
            <ul className="flex justify-between items-center mt-[10px]">
              {myFixedApplicationListState?.map((fixedFunc, index) => (
                <li className="text-center basis-[25%]" key={index}>
                  <a
                    href={fixedFunc?.targetLink}
                    className="hover:text-[#101116]"
                    target="_blank"
                    title={fixedFunc.applicationName}
                    data-spm={spmMap[fixedFunc.applicationType] || ''}
                  >
                    <SvgIcon
                      app="index"
                      iconName={fixedFunc.applicationType}
                      className="mx-auto mb-[4px] w-[28px] h-[28px]"
                      alt={fixedFunc.applicationName}
                    />
                    <span className="text-[#101116]">{fixedFunc.applicationName}</span>
                  </a>
                </li>
              ))}
            </ul>
            {/* <ReactSortable
              tag="ul"
              className="flex items-center flex-wrap mt-[30px]"
              list={myApplicationListState}
              setList={setMyApplicationListState}
              animation={150}
              disabled={!isEdit}
            > */}
            <ul className="flex items-center flex-wrap mt-[30px]">
              {myApplicationListState?.map((fixedFunc, index) => {
                const liContent = (
                  <>
                    <SvgIcon
                      app="index"
                      iconName={fixedFunc.applicationType}
                      className="mx-auto mb-[4px] w-[28px] h-[28px]"
                      alt={fixedFunc.applicationName}
                    />
                    <span className="text-[#101116]">{fixedFunc.applicationName}</span>
                    {isEdit && (
                      <MinusCircleFilled
                        className="absolute top-0 right-0"
                        style={{ color: '#CCCC' }}
                        onClick={(e) => removeFunction(fixedFunc, e)}
                      />
                    )}
                  </>
                );
                const liDom = isEdit ? (
                  liContent
                ) : (
                  <a href={fixedFunc?.targetLink} data-spm="0" target="_blank" title={fixedFunc.applicationName}>
                    {liContent}
                  </a>
                );
                return (
                  <li className={`relative text-center mb-[10px] basis-[25%]`} key={index}>
                    {liDom}
                  </li>
                );
              })}
            </ul>
            {/* </ReactSortable> */}
            <h2 className="font-bold text-[14px] mt-[10px]">常用应用</h2>
            <ul className="flex items-center flex-wrap mt-[30px]">
              {oftenUseApplicationListState?.map((fixedFunc, index) => {
                const liContent = (
                  <>
                    <SvgIcon
                      app="index"
                      iconName={fixedFunc.applicationType}
                      className="mx-auto mb-[4px] w-[28px] h-[28px]"
                      alt={fixedFunc.applicationName}
                    />
                    <span className="text-[#101116]">{fixedFunc.applicationName}</span>
                    {isEdit &&
                      !myApplicationListState.some((fun) => fun.applicationType === fixedFunc.applicationType) && (
                        <PlusCircleFilled
                          className="absolute top-0 right-0"
                          style={{ color: '#0093E6' }}
                          onClick={(e) => addFunction(fixedFunc, e)}
                        />
                      )}
                  </>
                );
                const liDom = isEdit ? (
                  liContent
                ) : (
                  <a href={fixedFunc?.targetLink} data-spm="0" target="_blank" title={fixedFunc.applicationName}>
                    {liContent}
                  </a>
                );

                return (
                  !myApplicationListState?.some((fun) => fun.applicationType === fixedFunc.applicationType) && (
                    <li className={`relative text-center mb-[10px] basis-[25%]`} key={index}>
                      {liDom}
                    </li>
                  )
                );
              })}
            </ul>
            <h2 className="font-bold text-[14px] mt-[10px]">更多</h2>
            <ul className="flex items-center flex-wrap mt-[30px]">
              {moreApplicationLisStatet?.map((fixedFunc, index) => {
                const liContent = (
                  <>
                    <SvgIcon
                      app="index"
                      iconName={fixedFunc.applicationType}
                      className="mx-auto mb-[4px] w-[28px] h-[28px]"
                      alt={fixedFunc.applicationName}
                    />
                    <span className="text-[#101116]">{fixedFunc.applicationName}</span>
                    {isEdit &&
                      !myApplicationListState.some((fun) => fun.applicationType === fixedFunc.applicationType) && (
                        <PlusCircleFilled
                          className="absolute top-0 right-0"
                          style={{ color: '#0093E6' }}
                          onClick={(e) => addFunction(fixedFunc, e)}
                        />
                      )}
                  </>
                );
                const liDom = isEdit ? (
                  liContent
                ) : (
                  <a href={fixedFunc?.targetLink} data-spm="0" target="_blank" title={fixedFunc.applicationName}>
                    {liContent}
                  </a>
                );
                return (
                  !myApplicationListState.some((fun) => fun.applicationType === fixedFunc.applicationType) && (
                    <li className={`relative text-center mb-[10px] basis-[25%] `} key={index}>
                      {liDom}
                    </li>
                  )
                );
              })}
            </ul>
          </div>
        </Drawer>
      </div>
      {/* 固定功能 */}
      <ul className="flex justify-between items-center mt-[10px] mb-0">
        {outSidemyApplicationListState?.slice(0, 4).map((fixedFunc, index) => (
          <a
            href={fixedFunc?.targetLink}
            target="_blank"
            title={fixedFunc.applicationName}
            className="text-center basis-[25%] hover:text-lcBlue custom-group min-w-[50px] h-[50px]"
            key={index}
            onClick={() =>
              indexBuriedPoint(indexBuriedPointMyfunMap[fixedFunc.applicationType] || '未定义op', fixedFunc?.targetLink)
            }
            onMouseEnter={() => changeEnter(fixedFunc.applicationType)}
            onMouseLeave={() => setIsHoverMySetting(false)}
            data-spm={spmMap[fixedFunc.applicationType] || ''}
          >
            <SvgIcon
              app="index"
              iconName={
                isHoverMySetting === fixedFunc.applicationType
                  ? fixedFunc.applicationType + '_hover'
                  : fixedFunc.applicationType
              }
              className="mx-auto mb-[4px] w-[28px] h-[28px]"
              alt={fixedFunc.applicationName}
            />
            <span className="text-[#101116] custom-group-hover-text-lcBlue text-[12px] antialiased">
              {fixedFunc.applicationName}
            </span>
          </a>
        ))}
      </ul>
      {/* 可配功能 */}
      <ul className="flex items-center flex-wrap mt-[10px]">
        <Skeleton loading={!outSidemyApplicationListState}>
          {outSidemyApplicationListState?.slice(4).map((fixedFunc, index) => (
            <a
              href={fixedFunc?.targetLink}
              target="_blank"
              title={fixedFunc.applicationName}
              className="text-center mb-[4px] h-[54px] basis-[25%] hover:text-lcBlue custom-group"
              key={index}
              data-spm="0"
              onClick={() =>
                indexBuriedPoint(
                  indexBuriedPointMyfunMap[fixedFunc.applicationType] || '未定义OP',
                  fixedFunc?.targetLink
                )
              }
            >
              <SvgIcon
                app="index"
                iconName={fixedFunc.applicationType}
                className="mx-auto mb-[4px] w-[28px] h-[28px]"
                alt={fixedFunc.applicationName}
              />
              <span className="text-[#101116] custom-group-hover-text-lcBlue text-[12px] antialiased">
                {fixedFunc.applicationName}
              </span>
            </a>
          ))}
        </Skeleton>
      </ul>
    </div>
  );
};

export default IndexMyApplication;
